import React, {useEffect, useState} from "react";
import {NomenclatureFormRead} from "../../components/nomenclature/form/NomenclatureFormRead";
import {useGetNomenclatureQuery} from "../../store/backend-api/backend.api";
import {useSearchParams} from "react-router-dom";
import {scrollStyle} from "../../utils/TailwindStyles";

export function ReadNomenclatureForm () {
    const [searchParams] = useSearchParams()
    const id = Number(searchParams.get("id"))
    const {data, isSuccess} = useGetNomenclatureQuery(id)
    const [key, setKey] = useState(0)

    useEffect(() => {
        setKey((prevState) => prevState + 1)
    }, [data])

    return (<div key={key} className={scrollStyle}>
        {isSuccess && (<NomenclatureFormRead data={data}/>)}
    </div>)
}